if (!customElements.get('tmg-save-toggle')) {
  const STORAGE_KEY = 'tmg:saved-products';
  const EVENT = 'tmg:saved-products-change';

  // Saved products are [{ id, handle }]; entries written by the first version were bare id strings.
  const readSaved = () => {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list
        .map((item) => (typeof item === 'object' && item ? { id: String(item.id), handle: item.handle || '' } : { id: String(item), handle: '' }))
        .filter((item) => item.id && item.id !== 'undefined');
    } catch (error) {
      return [];
    }
  };

  const writeSaved = (list) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // Storage unavailable (private mode / blocked): state still holds for this page view.
    }
  };

  const removeSaved = (productId) => {
    const id = String(productId);
    writeSaved(readSaved().filter((item) => item.id !== id));
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { productId: id, saved: false } }));
  };

  // Shared with the wishlist page (tmg-wishlist.js).
  window.tmgSavedProducts = { read: readSaved, remove: removeSaved, event: EVENT, storageKey: STORAGE_KEY };

  customElements.define(
    'tmg-save-toggle',
    class TmgSaveToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.productId = String(this.dataset.productId);
        this.onClick = this.onClick.bind(this);
        this.sync = this.sync.bind(this);

        this.button.addEventListener('click', this.onClick);
        document.addEventListener(EVENT, this.sync);
        window.addEventListener('storage', this.sync);
        this.sync();
      }

      disconnectedCallback() {
        this.button.removeEventListener('click', this.onClick);
        document.removeEventListener(EVENT, this.sync);
        window.removeEventListener('storage', this.sync);
      }

      setPressed(pressed) {
        this.button.setAttribute('aria-pressed', String(pressed));
        const label = pressed ? this.dataset.labelOn : this.dataset.labelOff;
        if (label) this.button.setAttribute('aria-label', label);
      }

      onClick(event) {
        // The card heart sits over a product link; never let the toggle navigate.
        event.preventDefault();
        event.stopPropagation();
        const pressed = this.button.getAttribute('aria-pressed') !== 'true';
        this.setPressed(pressed);

        const saved = readSaved().filter((item) => item.id !== this.productId);
        if (pressed) saved.push({ id: this.productId, handle: this.dataset.productHandle || '' });
        writeSaved(saved);
        document.dispatchEvent(new CustomEvent(EVENT, { detail: { productId: this.productId, saved: pressed } }));
      }

      sync(event) {
        if (event?.type === 'storage' && event.key !== STORAGE_KEY) return;
        if (event?.type === EVENT && event.detail?.productId !== this.productId) return;
        const pressed = event?.type === EVENT ? event.detail.saved : readSaved().some((item) => item.id === this.productId);
        this.setPressed(pressed);
      }
    }
  );
}
